import styled from '@emotion/styled'
import ContentWrapper from '@vio/atlas/helpers/ContentWrapper'

export const PageWrapper = styled(ContentWrapper)<{isMobile: boolean}>`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: ${({isMobile}) => (isMobile ? 'row' : 'column')};
`
